/**
 * `labor.device_session.page` values for pre-pack transfer packing (per transfer order job).
 */

export function transferPackLaborPageKeyForOrder(transferOrderId: number): string {
  return `transfer-pack-job:${String(transferOrderId)}`;
}

export function transferPackLaborExpectedPageFromPathname(pathname: string): string {
  const match = pathname.match(/^\/shipping\/pre-pack\/transfers\/(\d+)/);
  if (match) {
    const transferOrderId = Number.parseInt(match[1] ?? "", 10);
    if (Number.isFinite(transferOrderId) && transferOrderId > 0) {
      return transferPackLaborPageKeyForOrder(transferOrderId);
    }
  }
  return "";
}
